import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import ClassScheduleModal from './ClassScheduleModal';

const ClassSchedule = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [classSchedules, setClassSchedules] = useState([
        // Sample data (replace with actual data)
        {
            center: 'Downtown Center',
            level: 'Beginner',
            fees: 200,
            age: '5-10',
            timing: '10:00 AM - 11:00 AM',
            coach: 'John Smith',
            status: 'Active',
        },
        {
            center: 'Uptown Center',
            level: 'Intermediate',
            fees: 300,
            age: '11-15',
            timing: '11:30 AM - 12:30 PM',
            coach: 'Jane Doe',
            status: 'Deactive',
        },
        {
            center: 'Suburban Center',
            level: 'Advanced',
            fees: 400,
            age: '16-20',
            timing: '2:00 PM - 3:00 PM',
            coach: 'Mike Johnson',
            status: 'Active',
        },
    ]);
    const [filteredSchedules, setFilteredSchedules] = useState(classSchedules);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = classSchedules.filter((schedule) =>
            Object.values(schedule).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredSchedules(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, classSchedules]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredSchedules.length / itemsPerPage);
    const currentData = filteredSchedules.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setClassSchedules((prevSchedules) =>
            prevSchedules.map((schedule, i) =>
                i === index
                    ? { ...schedule, status: schedule.status === 'Active' ? 'Deactive' : 'Active' }
                    : schedule
            )
        );
    };

    const handleDelete = (index) => {
        const updatedData = currentData.filter((_, i) => i !== index);
        setClassSchedules(updatedData);
    };

    return (
        <>
           
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Class Schedule</h1>

                    {/* Add Fees Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add schedule
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Class Schedule Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Center</th>
                                <th>Level</th>
                                <th>Fees</th>
                                <th>Age</th>
                                <th>Timing</th>
                                <th>Coach</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((schedule, index) => (
                                    <tr key={index}>
                                        <td>{schedule.center}</td>
                                        <td>{schedule.level}</td>
                                        <td>{schedule.fees}</td>
                                        <td>{schedule.age}</td>
                                        <td>{schedule.timing}</td>
                                        <td>{schedule.coach}</td>
                                        <td>
                                            <button onClick={() => toggleStatus(index)}>
                                                <i
                                                    className={`fa ${schedule.status === 'Active'
                                                            ? 'fa-toggle-on'
                                                            : 'fa-toggle-off'
                                                        }`}
                                                ></i> {/* Toggle Status */}
                                            </button>
                                        </td>
                                        <td>
                                        <button className="edit-button" onClick={() => setIsModalOpen(true)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>
                                        No schedules found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>


            <ClassScheduleModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default ClassSchedule;
